import clsx from 'clsx'
import { observer } from 'mobx-react'
import { nanoid } from 'nanoid'
import * as React from 'react'
import { useContext, useMemo } from 'react'

import type { DefaultProps } from '@/types/common'

import { RadioGroupContext } from './context'
import S from './Radio.style'
import RadioGroup from './RadioGroup'

type Props = {
  value: string
  disabled?: boolean
} & DefaultProps

const Radio = ({ value, disabled = false, children, className, style }: Props) => {
  const context = useContext(RadioGroupContext)!
  const id = useMemo(() => nanoid(), [])
  const controlledParams = (context.value && { checked: context.value === value }) || undefined

  return (
    <>
      <input
        id={id}
        css={S.input}
        name={context.name}
        type="radio"
        value={value}
        ref={context.ref}
        onChange={context.onChange}
        disabled={disabled}
        {...controlledParams}
      />
      <label css={S.label} className={clsx('radio-label', className)} style={style} htmlFor={id}>
        {children}
      </label>
    </>
  )
}

Radio.Group = RadioGroup

export default observer(Radio)
